$(function () {
	'use strict';
	//slider
	var sliderOpt = {
		infinite: false,
		arrows: false,
		dots: true,
		autoplay: false,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		cssEase: "ease",
		lazyLoad: "progressive"
	};
	$('.slider').slick(sliderOpt);

	//スムーススクロール
	/* $('.simulationLink a, .footText__list a').click(function (e) {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		let h;

		if ($(this).closest('#productForm').hasClass('is-scroll')) {
			h = $('.header').outerHeight();
		} else {
			h = 0;
		}

		var position = target.offset().top - h;

		$.when(
			$("html, body").animate({ scrollTop: position }, 500),
			e.preventDefault(),
		).done(function () {
			var diff = target.offset().top - h;
			if (diff === position) {
			} else {
				$("html, body").animate({ scrollTop: diff }, 10);
			}
		});
		return false;
	}); */

	//フロートエリア（SP)
	const floatBtn = $("#closeFloat");
	const productForm = $('#productForm');
	//閉じるボタンが押されたら
	floatBtn.click(function (e) {
		$(this).parent().toggleClass('is-hidden');
		let h = productForm.outerHeight() * -1;
		//console.log(h);
		productForm.css({ 'bottom': h + 'px' });
	});

	//商品スライダー
	const productSlide = $('div[id^="Slider-Gallery-"]');

	
	function changeVariant() {

		// ▼▼ 必須：全ての選択肢の値を取得 ▼▼
		let selectedValues = [];
		$("variant-radios input:checked").each(function () {
			selectedValues.push($(this).val());
		});

		// 表示用テキスト（色の表示など）
		$('#selectedvariantName').text(selectedValues[0]);

		// スライダーを元に戻す
		$("#noShow").find(".item").each(function () {
			$(this).appendTo(productSlide);
		});

		// 並び替え
		let $elements = productSlide.find(".item").sort(function (a, b) {
			return $(a).data("index") > $(b).data("index") ? 1 : -1;
		});

		productSlide.empty();
		$elements.each(function () {
			productSlide.append($(this));
		});

		// ▼▼ フィルタリング（カンマ AND 条件 + 空/未ヒットは共通画像） ▼▼
		productSlide.find(".item").each(function () {

			let alt = $(this).find("img").data("alt");

			// alt が空 → 共通画像 → 表示
			if (!alt || alt.trim() === "") return;

			// カンマ区切りで条件を配列に
			const conditions = alt.split(",").map(s => s.trim());

			// 選択中の全バリアント値（例：["ベージュ", "160cm", "4枚セット"]）
			let selectedValues = [];
			$("variant-radios input:checked").each(function () {
				selectedValues.push($(this).val());
			});

			// ALT に prefix が含まれている条件だけを抽出
			// （「色__」または「高さ__」または「セット枚数__」で始まるもの）
			const validConditions = conditions.filter(cond =>
				cond.indexOf("色__") === 0 ||
				cond.indexOf("高さ__") === 0 ||
				cond.indexOf("セット枚数__") === 0
			);

			// 有効な条件が 1 つも無い → 共通画像扱い → 表示
			if (validConditions.length === 0) return;

			// AND 条件チェック
			const isMatchAll = validConditions.every(cond => {
				const prefix = cond.split("__")[0] + "__";
				const value = cond.replace(prefix, "").trim();
				return selectedValues.includes(value);
			});

			// AND 条件を満たさない → 非表示へ移動
			if (!isMatchAll) {
				$(this).appendTo("#noShow");
			}
		});

		// slider 起動
		var sliderOpt = {
			infinite: true,
			arrows: false,
			dots: true,
			autoplay: false,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
			cssEase: "ease",
			lazyLoad: "progressive",
			customPaging: function (slick, index) {
				var targetImage = slick.$slides.eq(index).find('img').attr('src');
				let a = targetImage.slice(0, -22);
				let b = "_96x";
				let c = targetImage.slice(-17);
				let thumb = a + b + c;
				return '<img src=" ' + thumb + ' " alt="" />';
			}
		};
		productSlide.slick(sliderOpt);
	}
	changeVariant();

	//バリアントを変更
	$("variant-radios").find("input").click(function (e) {
		productSlide.slick("unslick");
		changeVariant();
	});

});

const outer = $('.product__outer');
const productForm = $('#productForm');
$(window).scroll(function () {
	//フロートエリアの表示位置と高さを取得
	let y = outer.offset().top;
	let h = outer.outerHeight();
	//フォームエリアの高さが、モニタの高さを超えたらフロートを表示
	if ($(window).scrollTop() > h + y) {

		outer.css({ 'height': h + 'px' });
		productForm.addClass('is-scroll');
	} else {
		productForm.removeClass('is-scroll');
		outer.css({ 'height': 'auto' });
	}

});
